import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import NTNLogo from 'common/images/NTNLogo.jpg';
import PetasenseSvg from 'common/images/PetasenseSvg';
import { isNtnBrandTheme } from 'common/styles/organisationPartnerTheme';

// Brand from the theme, not redux: the app-shell fallback must render even
// when the store is what broke.
const BrandLogo = ({ theme }) => (isNtnBrandTheme(theme)
  ? <img src={NTNLogo} alt="NTN" height={28} />
  : <PetasenseSvg width={23} height={29} />);

BrandLogo.propTypes = {
  theme: PropTypes.object.isRequired
};

export default withTheme(BrandLogo);
